import ModalFormButton from './component';
import { ModalFormButtonProps } from './types';

export default ModalFormButton;
export type { ModalFormButtonProps };
